var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 12.1513C18.5 12.7372 18.052 13.2146 17.5 13.2146H10.587H10.413H3.5C2.948 13.2146 2.5 12.7372 2.5 12.1513V3.64495C2.5 3.05908 2.948 2.58166 3.5 2.58166H17.5C18.052 2.58166 18.5 3.05908 18.5 3.64495V12.1513ZM17.5 0.455078H3.5C1.846 0.455078 0.5 1.88627 0.5 3.64495V12.1513C0.5 13.91 1.846 15.3412 3.5 15.3412H9.5V17.4677H5.5C4.95 17.4677 4.5 17.9462 4.5 18.531C4.5 19.1158 4.95 19.5943 5.5 19.5943H15.5C16.05 19.5943 16.5 19.1158 16.5 18.531C16.5 17.9462 16.05 17.4677 15.5 17.4677H11.5V15.3412H17.5C19.154 15.3412 20.5 13.91 20.5 12.1513V3.64495C20.5 1.88627 19.154 0.455078 17.5 0.455078Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.efeb9e097e8542ec676e3947c611c8c1.svg";
export { ForwardRef as ReactComponent };